import { head, is, path, uniq } from 'ramda';

export const tv = (textKey, valueKey) => {
  const textPath = is(Object, textKey) && textKey.length && textKey.length > 0
    ? textKey
    : [textKey];

  const valuePath = is(Object, valueKey) && valueKey.length && valueKey.length > 0
    ? valueKey
    : [valueKey];

  if (textKey === undefined && valueKey === undefined) {
    return obj => {
      return {
        text: obj,
        value: obj,
      }
    }
  }
  return obj => {
    return {
      text: path(textPath)(obj),
      value: path(valuePath)(obj)
    };
  }
}
export const tvi = (textKey, valueKey, idKey) => {
  const textPath = is(Object, textKey) && textKey.length && textKey.length > 0
    ? textKey
    : [textKey];

  const valuePath = is(Object, valueKey) && valueKey.length && valueKey.length > 0
    ? valueKey
    : [valueKey];

  const idPath = is(Object, idKey) && idKey.length && idKey.length > 0
    ? idKey
    : [idKey];

  if (textKey === undefined && valueKey === undefined && idKey === undefined) {
    return obj => {
      return {
        text: obj,
        value: obj,
        id: obj,
      }
    }
  }
  return obj => {
    return {
      text: path(textPath)(obj),
      value: path(valuePath)(obj),
      id: path(idPath)(obj)
    };
  }
}

export const createTV = (array, textKey, valueKey) => {
  const firstElement = array?.[0];
  if (!firstElement) {
    return [];
  }

  const isStringArray = is(String, firstElement);
  if (isStringArray) {
    const uniqStrings = [];
    return array.map(e => {
      if (uniqStrings.includes(e) && e != '-') {
        return '';
      }
      uniqStrings.push(e);
      return e;
    })
      .filter(e => e)
      .map(tv());
  }
  return array.
    map(tv(textKey, valueKey)).
    filter(e => e.text !== "" && e.text !== null && e.text !== undefined). // Some arrays returns Empty String / Null or Undefined - Clearing those
    filter((tvItem, index, self) => {
      const firstIndex = self.findIndex((t) => t.value === tvItem.value);

      if (index !== firstIndex) {
        console.error(`
To Details Developers: 
In CreateTVI Function Argument, You must pass in a Unique Value for each item.
If you want to allow duplicate values, pass in the 4th argument as true.
The effected Array TextKey : ${textKey}, ValueKey : ${valueKey}
Here duplicate value found: ${tvItem.text} ${tvItem.value}`);
      }

      return index === firstIndex;
    });
}
export const createTVI = (array, textKey, valueKey, idKey, allowDuplicateValues = false) => {
  const firstElement = array?.[0];
  if (!firstElement) {
    return [];
  }

  const isStringArray = is(String, firstElement);
  if (isStringArray) {
    const uniqStrings = [];
    return array.map(e => {
      if (uniqStrings.includes(e) && e !== '-') {
        return '';
      }
      uniqStrings.push(e);
      return e;
    })
      .filter(e => e)
      .map(tv());
  }
  return array.
    map(tvi(textKey, valueKey, idKey)).
    filter(e => e.text !== "" && e.text !== null && e.text !== undefined). // Some arrays returns Empty String / Null or Undefined - Clearing those
    filter((tvItem, index, self) => {
      if (allowDuplicateValues) {
        return true;
      }

      const firstIndex = self.findIndex((t) => t.value === tvItem.value);

      if (index !== firstIndex) {
        console.error(`
To Details Developers: 
In CreateTVI Function Argument, You must pass in a Unique Value for each item.
If you want to allow duplicate values, pass in the 4th argument as true.
The effected Array TextKey : ${textKey}, ValueKey : ${valueKey}, IDKey : ${idKey}
Here duplicate value found: ${tvItem.text} ${tvItem.value} ${tvItem.id}`);
      }

      return index === firstIndex;
    });
}
